import React from 'react';

import FindAccommodations from '../../GlobalPrivileges/FindAccommodations';
import UTMap from '../../UTMap';

import { useStatsig } from '../../hooks/useStatsig';
import { EventTypes } from '../../../utils/events';

const Location = ({ event, surface, 'data-testid': dataTestId }) => {
    const location = (event?.eventLocations[0]) || {};
    const { checkGate, featureGates } = useStatsig();

    const isEventTypeFreePlay = event?.eventTypeId === EventTypes.FREE_PLAY || event?.eventType?.id === EventTypes.FREE_PLAY;
    const isEventTypeFlexLeague = event?.eventTypeId === EventTypes.FLEX_LEAGUE || event?.eventType?.id === EventTypes.FLEX_LEAGUE;
    const isFindAccommodationsEnabled = checkGate(featureGates.GLOBAL_PRIVILEGES_FIND_ACCOMMODATIONS);
    const showGlobalPrivilegesFindAccommodations = isFindAccommodationsEnabled && !isEventTypeFreePlay && !isEventTypeFlexLeague;
    const findAccommodationsStyle = showGlobalPrivilegesFindAccommodations ? 'pl12 pr12' : '';

    let directionsUrl = '';
    if (location?.latLng) {
        const joinedLocation = [location.placeName, location.streetAddress, location.display].filter(val => val).join(' ');
        directionsUrl = `https://www.google.com/maps/dir//${joinedLocation.split(' ').join('+')}/@${location.latLng[0]},${location.latLng[1]}`;
    }
    return (
        <div className="location-wrapper">
            <div className="location-details">
                <div className="icon-wrapper">
                    <i className="uts uts-time" />
                    <p>
                        {event?.eventSchedule?.eventDatesLong}
                    </p>
                </div>
                <div className="icon-wrapper">
                    <i className="uts uts-location" />
                    <div>
                        {location.placeName &&
                        <div className="text-medium">{location.placeName}</div>}
                        {location.streetAddress && <div>{location.streetAddress}</div>}
                        {location.cityStateZip && <div>{location.cityStateZip}</div>}
                    </div>
                </div>
                <hr className="div" />
                <div className="row">
                    <div className="col-md-6">
                        <a href={directionsUrl} target="_blank" rel="noopener noreferrer" data-testid={dataTestId && `${dataTestId}.directions-link`}><i className="uts uts-directions" /> Get
                            directions
                        </a>
                    </div>
                </div>
            </div>
            <div className={`map ${findAccommodationsStyle}`}>
                {location?.latLng && (
                    <>
                        <UTMap
                            lat={location.latLng[0]}
                            lng={location.latLng[1]}
                            placeId={location.googlePlaceId}
                            placeName={location.googleFormattedName}
                            height="216px"
                        />
                        {showGlobalPrivilegesFindAccommodations && <FindAccommodations surface={surface} event={event} />}
                    </>
                )}
            </div>
        </div>
    );
};

export default Location;
